import { render } from "./toasts.vue?vue&type=template&id=3dac9840"
import script from "./toasts.vue?vue&type=script&lang=js"
export * from "./toasts.vue?vue&type=script&lang=js"

import "./toasts.vue?vue&type=style&index=0&id=3dac9840&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__